import React from "react";

export enum Privilegio {
    Normal = 1,
    Gestao = 2,
    Admnistrador = 999,
}

export interface IUser {
    usucodigo?: number;
    usuemail?: string;
    ususenha?: string;
    usutoken?: string;
    usunome?: string;
    token?: string;
    refresh?: string;
    versao?: string;
    grupo?: any;
    privilegio?: Privilegio;
}

export interface IContext extends IUser {
    grupos: any;
    authenticate: (usuemail: string, ususenha?: string, usutoken?: string, grupo?: any) => Promise<void>;
    signin: (usuemail: string, usunome: string) => Promise<void>
    validateCode: (usuemail: string, usuvalcodigo: string) => Promise<string>
    logout: () => void;
    alterUser: (data: any) => void;
    get: (prefix: string, params?: any) => Promise<void>;
    post: (url: string, data: any) => Promise<void>;
    setGruSuperiores: (grupos: any) => void;
}

export interface IAuthProvider {
    children: React.JSX.Element;
}